import SEO from "../components/SEO";

const CookiePolicyPage = () => {
  return (
    <div className="min-h-screen pt-24 bg-[#FAF9F6]">
      <SEO
        title="Cookie Policy"
        description="Cookie Policy for Magnus Kor Talent Partners. How we use cookies and similar technologies on our website."
        canonical="https://magnuskor.com/cookies"
      />
      <div className="max-w-3xl mx-auto px-6 py-16">
        <h1 className="font-display text-3xl md:text-4xl text-[#1A1A1A] mb-2" data-testid="cookies-title">Cookie Policy</h1>
        <p className="text-sm text-gray-400 mb-10">Last updated: February 2026</p>

        <div className="prose prose-gray max-w-none space-y-8 text-gray-600 text-[15px] leading-relaxed">
          <section>
            <h2 className="text-lg font-semibold text-[#1A1A1A] mb-3">1. What Are Cookies</h2>
            <p>Cookies are small text files placed on your device when you visit a website. They help websites function properly, remember your preferences, and provide analytics data. This policy explains how Magnus Kor Talent Partners (magnuskor.com) uses cookies.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[#1A1A1A] mb-3">2. Cookies We Use</h2>

            <h3 className="text-base font-medium text-[#1A1A1A] mt-4 mb-2">Essential Cookies</h3>
            <p>These are necessary for the website to function. They enable core features like page navigation, form submissions, and secure access to admin areas. You cannot opt out of essential cookies.</p>

            <h3 className="text-base font-medium text-[#1A1A1A] mt-4 mb-2">Functional Cookies</h3>
            <p>These remember your preferences (e.g., tool inputs, calculator settings) to provide a better experience. They do not track you across other websites.</p>

            <h3 className="text-base font-medium text-[#1A1A1A] mt-4 mb-2">Analytics Cookies</h3>
            <p>We may use analytics services to understand how visitors interact with our website. These cookies collect anonymised data about page visits, time on site, and traffic sources. No personally identifiable information is collected through analytics cookies.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[#1A1A1A] mb-3">3. Third-Party Cookies</h2>
            <p>Our website may set cookies from third-party services including:</p>
            <ul className="list-disc pl-6 mt-2 space-y-1">
              <li><strong>Google Analytics:</strong> Website traffic analysis (if enabled)</li>
              <li><strong>Calendly:</strong> Appointment scheduling widget</li>
              <li><strong>LinkedIn:</strong> Social media integration</li>
            </ul>
            <p className="mt-2">These third parties have their own privacy and cookie policies. We encourage you to review them.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[#1A1A1A] mb-3">4. How to Manage Cookies</h2>
            <p>You can control cookies through your browser settings. Most browsers allow you to:</p>
            <ul className="list-disc pl-6 mt-2 space-y-1">
              <li>View cookies stored on your device</li>
              <li>Delete individual or all cookies</li>
              <li>Block cookies from specific or all websites</li>
              <li>Set preferences for first-party vs third-party cookies</li>
            </ul>
            <p className="mt-2">Note: Disabling essential cookies may affect website functionality.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[#1A1A1A] mb-3">5. Local Storage</h2>
            <p>In addition to cookies, we use browser local storage to maintain your session state when logged into the admin dashboard. This data is stored locally on your device and is not transmitted to third parties.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[#1A1A1A] mb-3">6. Changes to This Policy</h2>
            <p>We may update this Cookie Policy from time to time. The "Last updated" date at the top of this page indicates when this policy was last revised.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[#1A1A1A] mb-3">7. Contact</h2>
            <p>For questions about our use of cookies, contact us at <a href="mailto:office@magnuskor.com" className="text-[#B8860B] hover:underline">office@magnuskor.com</a>.</p>
            <p className="mt-2">L&D Nexus Limited, 71-75 Shelton Street, Covent Garden, London, WC2H 9JQ</p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default CookiePolicyPage;
